module.exports = __webpack_public_path__ + "img/icon_tree_dot.42fec6a7.svg";